export const BaseURL = "https://kansaswallet.in/"; //live
// export const BaseURL = "http://192.168.1.125:8001/";
// export const BaseURL = "http://192.168.4.209:8000/"; //local
// export const BaseURL = "http://cbe.themaestro.in:1008/";
// export const BaseURL = "http://192.168.1.124:8002/";
// export const BaseURL = "http://192.168.1.175:8002/";
export const MapAPIKey = "AIzaSyCHdEnmv9_RdcuduiyOFlbYikWRXrfSssM";
export const DEFAULT_LOCATION = {
  lat: 12.9583692,
  lng: 77.6408356,
};

export const phoneExp = /^[6,7,8,9]{1}[0-9]{9}$/;
export function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export const getVideoID = (url) => {
  return url.slice(url.lastIndexOf("/") + 1);
};

export const getVideoThumbnail = (url) => {
  return `http://img.youtube.com/vi/${getVideoID(url)}/0.jpg`;
};
export const getNumberFormat = (num) => {
  let tempNumber = num?.toString().replace("₹", "");
  let sign = "";
  if (tempNumber?.toString().includes("-")) {
    sign = "-";
    tempNumber = tempNumber?.toString().replace("-", "");
  }
  let x = parseFloat(tempNumber).toFixed(2);
  let a =
    x.toString().split(".")[0].length > 3
      ? x
          .toString()
          .substring(0, x.toString().split(".")[0]?.length - 3)
          .replace(/\B(?=(\d{2})+(?!\d))/g, ",") +
        "," +
        x.toString().substring(x?.toString().split(".")[0].length - 3)
      : x.toString();

  return "₹ " + sign + a;
};

export const formatINR = (value) => {
  return value.toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export function isPWA() {
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true
  );
}

// Utility file
export function isStandalone() {
  return window.matchMedia("(display-mode: standalone)").matches;
}

export const isMobileView =
  window.matchMedia("(max-width: 768px)").matches ||
  /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

export const maxquantity = 100;

export const planActiveText =
  "This feature is available only with an active plan. Please choose a plan to continue.";

export const BILLING_ADDRESS_LIST_KEY = "billing_address";
export const SHIPPING_ADDRESS_LIST_KEY = "shipping_address";
export const ADDRESS_ID_PRE_TEXT = "address";

export const SAVE_ADDRESS_LIST = [
  {
    id: 1,
    name: "Address 1",
    keyName: "address1",
  },
  {
    id: 2,
    name: "Address 2",
    keyName: "address2",
  },
  {
    id: 3,
    name: "Address 3",
    keyName: "address3",
  },
];

export const base64ToBlob = (base64Data, contentType = "application/pdf") => {
  if (!base64Data || typeof base64Data !== "string") return null;
  try {
    const cleanBase64 = base64Data.includes("base64,")
      ? base64Data.split("base64,")[1]
      : base64Data;
    const trimmed = cleanBase64.trim().replace(/\s/g, "");
    const byteCharacters = atob(trimmed);
    const byteNumbers = new Uint8Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    return new Blob([byteNumbers], { type: contentType || "application/pdf" });
  } catch (err) {
    console.error("Error converting base64 to blob:", err);
    return null;
  }
};

export const parseBase64Response = (res) => {
  const root = res?.data?.data || res?.data || res;

  let base64 = null;
  if (typeof root === "string") {
    base64 = root;
  } else if (root && typeof root === "object") {
    base64 =
      root.base64_content ||
      root.base64_data ||
      root.file_content ||
      root.base64 ||
      root.content ||
      root.pdf_base64 ||
      (typeof root.data === "string" ? root.data : null);
  }

  let fileName = null;
  let contentType = "application/pdf";
  let url = null;

  if (root && typeof root === "object") {
    fileName =
      root.file_name || root.filename || root.fileName || root.name || null;
    contentType =
      root.content_type ||
      root.contentType ||
      root.type ||
      "application/pdf";
    url = root.url || root.billing_url || root.invoice_url || null;
  }

  return {
    base64,
    fileName,
    contentType,
    url,
  };
};

